module.exports = __webpack_public_path__ + "static/media/apple_white.5c840ce0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/apple_white.svg
// module id = 98
// module chunks = 0